import { createContext } from 'react';

const ShareContext = createContext(void 0);

ShareContext.displayName = 'context(Share)';

export default ShareContext;